
<template>
    <q-dialog
        seamless
        v-model="isShowLangTips"
        position="bottom"
    >
        <div class="lang-tip-box">
            <div class="left">
                <!-- ↓ 双语提示 -->
                <p>
                    Do you want to switch the interface language to:<br/>
                    是否将页面语言切换为：
                </p>
                <em class="target">
                    <IconSvgUse
                        class='icon'
                        :use="`flag-${sLangSuggested}`"
                        style="width: 24px; height: 24px"
                    />
                    {{ $t(`lang.${sLangSuggested}`) }}
                </em>
            </div>
            <!-- 左右分界 -->
            <div class="right">
                <ButtonGrayButton blue @click="setLang('switch')">
                    Yes
                </ButtonGrayButton>
                <ButtonGrayButton v-close-popup @click="setLang('ignore')">
                    No
                </ButtonGrayButton>
            </div>
        </div>
    </q-dialog>
</template>

<script lang="ts" setup>
import type {LangOperate} from '@/stores/settings';
import {inferNewLang, toRecordNewLanguage} from '@/i18n/langSettingFn'; 
import useSettingsStore from '@/stores/settings';

const props = defineProps({
    lang: {
        type: String, // 将收到用户上次选择的语言，或空字符（在没登录等情况下） 
        required: true,
    },
});

const settingStore = useSettingsStore();
const isShowLangTips = ref(false);
const sLangSuggested = ref('');

// ↓ 判断要不要提示用户切换语言 
const checkAndShowTips = async (sUserLang='')=>{
    // ↓ 用户已经忽略了界面语言切换，不要再弹出 
    if (settingStore.langOperation === 'ignore') {
        return;
    }
    sLangSuggested.value = inferNewLang(sUserLang);
    const sCurrentLang = useNuxtApp().$i18n.locale.value; 
    const theSame = sLangSuggested.value === sCurrentLang;
    if (theSame || !sLangSuggested.value) {
        console.log('放弃提示语言变更，界面语言与推荐语言：', sCurrentLang, sLangSuggested.value);
        return;
    }
    console.log("界面语言应为：", sLangSuggested.value);
    isShowLangTips.value = true;
    // await Sleep(6_000);
    // isShowLangTips.value = false; // 自动关闭 
}

// ↓ 执行切换语言（刷新页面）
const setLang = async (command: LangOperate) => {
    isShowLangTips.value = false;
    settingStore.langOperation = command; // 记录操作，防止再弹出语言建议 
    if (command != 'switch') return;
    const res = await toRecordNewLanguage(sLangSuggested.value);
    const sNewPath = useNuxtApp().$switchLocalePath(sLangSuggested.value);
    if (1 && import.meta.dev){
        console.log(`记录新语言到服务器：`, res); 
        console.log(`切换语言到：${sLangSuggested.value} =>`, sNewPath); 
    }
    location.href = sNewPath;
}

onMounted(()=>{
    checkAndShowTips(props.lang);
});

</script>

<style lang="scss" scoped>

.lang-tip-box{
    width: 450px;
    background: #1B2636;
    box-shadow: 0px -3px 9px #0D131C;
    color: white; 
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 10px 20px 30px;

    .left{
        flex: 1 1 auto;
        margin-right: 15px;
        .target{
            display: flex;
            align-items: center;
            font-size: 17px;
            font-weight: bold;
            margin-top: 3px;
            .icon{
                display: inline-block;
                margin-right: 5px;
            }
        }
    }
    .right{
        display: flex;
        flex-direction: column;
        gap: 10px;

    }
}

</style>
